import {GiocoVilla, SolveEnum} from "./js/GiocoVilla";
import WebGL from 'three/examples/jsm/capabilities/WebGL.js';

// noinspection JSConstantReassignment
window.SolveEnum = SolveEnum;
window.GiocoVilla = GiocoVilla;
window.creaGioco = creaGioco;
window.checkWebGL = checkWebGL;

export function checkWebGL() {
    if (WebGL.isWebGLAvailable()) {
        return true;
    } else {
        return WebGL.getWebGLErrorMessage();
    }
}

export function creaGioco(url, canvas, resource_dir, options) {
    return new GiocoVilla(url, canvas, resource_dir, options);
}

